import React, { useState } from "react";
import "./Furniture.css";
import { determineImageFormat } from "../components/DetermineImageFormat";
import GalleryPopup from "../components/GalleryPopup2";
import { useData } from "../pages/DataContext";

const SELECTED_CATEGORY = "Stolove-zostavy";

function Furniture() {
  const { nabytok: furnitureItems } = useData();
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const dimensions = { width: 640, height: 400 }; // pre Stolove-zostavy

  const filteredFurnitureItems = furnitureItems.filter((item) =>
    item.tags?.includes(SELECTED_CATEGORY)
  );

  const openGallery = (id) => {
    const idx = filteredFurnitureItems.findIndex((item) => item.id === id);
    if (idx === -1) return;
    setSelectedImageIndex(idx);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setSelectedImageIndex(null);
    setIsGalleryOpen(false);
  };

  return (
    <section className="furniture-body">
      <div className="allFurnitureItems">
        {filteredFurnitureItems.map((oneStockItem, index) => {
          const isFirstThree = index < 3;
          return (
            <div key={oneStockItem.id} className="oneFurnitureItem-Stolove-zostavy">
              <div className="oneFurnitureItem-wrapper">
                <div
                  onClick={() => openGallery(oneStockItem.id)}
                  className="fur-item-image-container-Stolove-zostavy"
                >
                  <img
                    loading={isFirstThree ? "eager" : "lazy"}
                    src={determineImageFormat(oneStockItem.TimageWebp, oneStockItem.TimageJpg)}
                    alt={oneStockItem.title}
                    width={dimensions.width}
                    height={dimensions.height}
                    className="fur-item-Timage"
                  />
                  <div className="fur-item-blur"></div>
                </div>
              </div>
              <div className="fur-item-caption">
                <h1 onClick={() => openGallery(oneStockItem.id)}>{oneStockItem.title}</h1>
              </div>
            </div>
          );
        })}
      </div>

      {isGalleryOpen && (
        <GalleryPopup
          images={filteredFurnitureItems.map((item) => ({
            id: item.id,
            image: determineImageFormat(item.TimageWebp, item.TimageJpg),
          }))}
          selectedIndex={selectedImageIndex}
          onClose={closeGallery}
          filteredStockItems={filteredFurnitureItems}
          selectedCategory={SELECTED_CATEGORY}
        />
      )}
    </section>
  );
}

export default Furniture;
